



































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from 'frontend/components/Button.vue';
import { LearningPathLevel, LearningPathV2 } from 'frontend/types/learningPathV2';
import Tag from 'frontend/views/learningPathV2/Tag.vue';
import BadgeLabel from 'frontend/views/learningPathV2/BadgeLabel.vue';
import ProgressBar from 'frontend/views/learningPathV2/ProgressBar.vue';

@Component({
  components: {
    BadgeLabel,
    Button,
    ProgressBar,
    Tag,
  },
})
export default class LevelCard extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) private hideStats!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private isNux!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private isPlacedOut!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private isRecommended!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private isCurrentLevel!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private isActive!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) private loading!: boolean;
  @Prop({ type: Object, required: true }) private learningPath!: LearningPathV2;
  @Prop({ type: Object, required: true }) private level!: LearningPathLevel;

  private get badgeColor(): string {
    if (this.isComplete || this.isPlacedOut) {
      return '#179E7E';
    }
    if (this.isRecommended) {
      return '#F2BD57';
    }
    return this.learningPath.color_scheme.s_500;
  }

  private get ctaCopy(): string {
    if (this.isRecommended) {
      return 'Get started';
    }
    if (this.isComplete || this.isPlacedOut) {
      return 'View level';
    }
    if (this.isStarted) {
      return 'Continue';
    }
    return `Start level ${this.level.number}`;
  }

  private get ctaAriaLabel(): string {
    if (this.isRecommended) {
      return `Get started with level ${this.level.number}`;
    }
    if (this.isComplete || this.isPlacedOut) {
      return `View level ${this.level.number}`;
    }
    if (this.isStarted) {
      return `Continue level ${this.level.number}`;
    }
    return `Start level ${this.level.number}`;
  }

  private get isComplete(): boolean {
    return this.level.percent_complete === 100;
  }

  private get isStarted(): boolean {
    return !this.isComplete && this.level.percent_complete > 0;
  }
}
